
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":".2","cx":"40","cy":"40","r":"40","fill":"#27AE60"}}),_c('circle',{attrs:{"cx":"40","cy":"40","r":"32.421","fill":"#27AE60"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.372 25.68c.7.612.771 1.676.158 2.376L34.952 55.004a1.684 1.684 0 01-2.459.082L22.388 44.98a1.684 1.684 0 112.382-2.382l8.832 8.833 22.394-25.593c.612-.7 1.676-.77 2.376-.158z","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    